/**
 * Contacts
 */

import React from 'react';
import PropTypes from 'prop-types';
import Filter from './Filter/';
import Contact from './Contact/';
import './Contacts.scss';

class Contacts extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchValue: '',
            titleFilter: -1,
        };
    }

    updateSearchValue = (e) => {
        const searchValue = e.target.value;

        this.setState({
            searchValue: searchValue,
        });
    };

    updateFilter = (e) => {
        const filter = parseInt(e.target.dataset.filter);
        const filterType = e.target.dataset.filterType;

        this.setState({
            [filterType]: filter,
        });
    };

    applyFilter = (contacts, filter, filterType) => {
        if (filter !== -1) {
            contacts = contacts.filter((contact) => {
                return contact[filterType].includes(filter);
            });
        }
        return contacts;
    };

    render() {
        const { titles } = this.props;
        const { searchValue, titleFilter } = this.state;
        let contacts = Object.assign([], this.props.contacts);

        if (searchValue.length > 0) {
            contacts = contacts.filter(
                (contact) =>
                    contact.title.rendered.search(
                        new RegExp(searchValue, 'i')
                    ) !== -1
            );
        }

        contacts = this.applyFilter(contacts, titleFilter, 'contactTitle');

        return (
            <div>
                <div className="Contacts">
                    <div className="Contacts__FilterContainer">
                        <Filter
                            filters={titles}
                            filter={titleFilter}
                            filterType="titleFilter"
                            label="Välj avdelning"
                            updateFilter={this.updateFilter}
                        />
                        <input
                            className="Contacts__Input"
                            type="text"
                            onChange={this.updateSearchValue}
                            placeholder="Sök på person"
                        />
                    </div>
                    {contacts.length > 0 ? (
                        <div className="Contacts__ContactList">
                            {contacts.map((contact, index) => (
                                <div className="Contacts__Contact" key={index}>
                                    <Contact contact={contact} />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="Contacts__ContactList">
                            <p className="Contacts__NoResult">Inga resultat</p>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

Contacts.defaultProps = {
    contacts: [],
    titles: [],
};

Contacts.propTypes = {
    contacts: PropTypes.array,
    titles: PropTypes.array,
};

export default Contacts;
